export const cardContentSx = { px: '24px', minHeight: '232px', display: 'flex' };

export const loadingBoxSx = {
  display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1,
};

export const parentBoxSx = {
  display: 'flex', flexDirection: 'column', alignItems: 'start', flex: 1,
};

export const mainBoxSx = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  mb: '8px',
};

export const iconBtnSx = {
  py: 0,
  '&.MuiButtonBase-root:hover': {
    bgcolor: 'transparent',
  },
};

export const textBtnSx = {
  paddingLeft: '0px !important',
  '&.MuiButtonBase-root:hover': {
    bgcolor: 'transparent',
  },
};
